import { PropsWithChildren } from 'react';
import { Fragment } from 'react/jsx-runtime';

import { cn } from '@/utils/classname';

export const TimelineEvent = ({
  className,
  index,
  isSelected,
  isPreviousSelected,
  children,
  position = 'center',
}: {
  className?: string;
  index: number;
  isSelected?: boolean;
  isPreviousSelected?: boolean;
  position?: 'center' | 'left';
} & PropsWithChildren) => {
  return (
    <Fragment key={index}>
      {index > 0 && (
        <div className={cn('relative', position === 'left' && 'left-6')}>
          <div className="bg-chariot-stroke absolute -top-8 h-[64px] w-px"></div>
          <div
            className={cn(
              'bg-chariot-stroke absolute -top-10 -left-2 size-4 rounded-full',
              isPreviousSelected && 'bg-chariot-brand-primary'
            )}
          />
          <div
            className={cn(
              'bg-chariot-stroke absolute -bottom-10 -left-2 size-4 rounded-full',
              isSelected && 'bg-chariot-brand-primary'
            )}
          />
        </div>
      )}
      <div id={`asset-affiliation-${index}`} className={cn('w-full')}>
        <div
          className={cn(
            'border-chariot-stroke w-full rounded-md border-2 p-4',
            isSelected && 'border-chariot-brand-primary',
            className
          )}
        >
          {children}
        </div>
      </div>
    </Fragment>
  );
};
